import { Vertical, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { IconSettings } from '@tabler/icons-react'
import { Form, Select, Switch } from 'antd'
import type { MapSettings } from '../types'

type SettingsDropdownProps = {
  settings: MapSettings | null
  handleUpdateMapSettings: <K extends keyof MapSettings>(key: K, value: MapSettings[K]) => void
}

export function SettingsDropdown({ settings, handleUpdateMapSettings }: SettingsDropdownProps) {
  return (
    <Vertical
      style={{
        backgroundColor: 'var(--bg-1)',
        borderRadius: '8px',
        boxShadow: '0 2px 2px rgba(60,64,67,0.3),0 1px 3px 1px rgba(60,64,67,0.15)',
        width: '200px',
      }}
      className='p-2'
      gap={6}
    >
      <Horizontal verticalCenter justifyContent='space-between'>
        <Texto weight={'bold'}>View Settings</Texto>
        <IconSettings stroke={1.5} size={18} />
      </Horizontal>

      <Form.Item
        label='Show points of interest'
        style={{ marginBottom: 0 }}
        initialValue={settings?.showLocations || 'all'}
      >
        <Select
          title='Show points of interest'
          style={{ width: '100%' }}
          options={['All', 'Only on route', 'None'].map((option) => ({
            label: option,
            value: option.toLowerCase().replace(/\s+/g, '_'),
          }))}
          value={settings?.showLocations || 'all'}
          onChange={(value) =>
            handleUpdateMapSettings<'showLocations'>('showLocations', value as MapSettings['showLocations'])
          }
        />
      </Form.Item>
      <Form.Item label='Show breadcrumbs' style={{ marginBottom: 0 }} initialValue={settings?.showBreadcrumbs}>
        <Switch
          title='Show breadcrumb markers'
          checked={settings?.showBreadcrumbs}
          onChange={(checked) => handleUpdateMapSettings<'showBreadcrumbs'>('showBreadcrumbs', checked)}
        />
      </Form.Item>
    </Vertical>
  )
}
